import {
  Apps,
  AppsFilled,
  Automation,
  AutomationFilled,
  CreditCardOutline,
  CreditCardOutlineFilled,
  Notifications,
  NotificationsFilled,
  People,
  PeopleFilled,
  Report,
  ReportFilled,
  Settings,
  SettingsFilled,
  Tickets,
  TicketsFilled,
} from "@livechat/design-system-icons";

import { NavigationItemInterface, NavigationItems } from "interfaces/navigationItem";

import { ResponsiveBreakpointType } from "./responsive-breakpoint";
import Role from "./role";

export const NAVIGATION_ITEMS: NavigationItemInterface[] = [
  {
    id: NavigationItems.Tickets,
    name: "Tickets",
    path: "/tickets",
    iconName: Tickets,
    iconNameFilled: TicketsFilled,
    placement: "top",
    breakpoints: [ResponsiveBreakpointType.Desktop, ResponsiveBreakpointType.Mobile],
    activeWhenAppAccessNotAllowed: false,
  },
  {
    id: NavigationItems.Agents,
    name: "Agents",
    path: "/agents",
    iconName: People,
    iconNameFilled: PeopleFilled,
    placement: "top",
    breakpoints: [ResponsiveBreakpointType.Desktop, ResponsiveBreakpointType.Mobile],
    activeWhenAppAccessNotAllowed: true,
  },
  {
    id: NavigationItems.Reports,
    name: "Reports",
    path: "/reports",
    iconName: Report,
    iconNameFilled: ReportFilled,
    placement: "top",
    breakpoints: [ResponsiveBreakpointType.Desktop],
    permissions: [Role.Owner, Role.Normal],
    activeWhenAppAccessNotAllowed: false,
  },
  {
    id: NavigationItems.Automations,
    name: "Automations",
    path: "/automations",
    iconName: Automation,
    iconNameFilled: AutomationFilled,
    placement: "top",
    breakpoints: [ResponsiveBreakpointType.Desktop],
    permissions: [Role.Owner, Role.Normal],
    activeWhenAppAccessNotAllowed: false,
  },
  {
    id: NavigationItems.Marketplace,
    name: "Marketplace",
    path: "/marketplace",
    iconName: Apps,
    iconNameFilled: AppsFilled,
    placement: "top",
    breakpoints: [ResponsiveBreakpointType.Desktop],
    permissions: [Role.Owner, Role.Normal],
    activeWhenAppAccessNotAllowed: false,
  },
  {
    id: NavigationItems.Subscription,
    name: "Subscribe",
    path: "/subscription",
    iconName: CreditCardOutline,
    iconNameFilled: CreditCardOutlineFilled,
    placement: "bottom",
    breakpoints: [ResponsiveBreakpointType.Desktop, ResponsiveBreakpointType.Mobile],
    activeWhenAppAccessNotAllowed: true,
  },
  {
    id: NavigationItems.Settings,
    name: "Settings",
    path: "/settings",
    iconName: Settings,
    iconNameFilled: SettingsFilled,
    placement: "bottom",
    breakpoints: [ResponsiveBreakpointType.Desktop, ResponsiveBreakpointType.Mobile],
    permissions: [Role.Owner, Role.Normal],
    activeWhenAppAccessNotAllowed: false,
  },
  {
    id: NavigationItems.News,
    name: "News",
    iconName: Notifications,
    iconNameFilled: NotificationsFilled,
    placement: "bottom",
    breakpoints: [ResponsiveBreakpointType.Desktop],
    activeWhenAppAccessNotAllowed: true,
  },
];
